/**
 * all actions for documents state
 *
 * Created by Min on 21/08/18
 */

import C from '../constants'


// action to set doc sign link
export const setDocSignStatus = objectVal => {
    return {
        type: C.SET_DOC_SIGN_STATUS,
        payload: objectVal
    }
}

// action to set documents data
export const setDocumentData = objectVal => {
    return {
        type: C.SET_DOCUMNENTS_DATA,
        payload: objectVal
    }
}


// action to set documents loader
export const showDocumentsLoader = booleanVal => {
    return {
        type: C.SET_DOCUMNENTS_LOADER,
        payload: booleanVal
    }
}

// action to set the documents fetch success state
export const setDocumentsFetchSuccess = booleanVal => {
    return {
        type: C.SET_DOCUMENTS_FETCH_SUCCESS,
        payload: booleanVal
    }
}

/* -----------------------------------------------------------------------------
    ACTIONS CREATORS
----------------------------------------------------------------------------- */
// call the action to fetch doc sign link
export const getDocSignStatus = () => {
    return {
        type: C.FETCH_DOC_SIGN_STATUS,
    }
}

// call the action to fetch documents data
export const getDocumentsData = () => {
    return {
        type: C.FETCH_DOCUMNENTS_DATA,
    }
}



// WEBPACK FOOTER //
// ./src/actions/documentsActions.js